import { render, staticRenderFns } from "./BalanceReportPayerFieldsModal.vue?vue&type=template&id=5dcc8b44&scoped=true"
import script from "./BalanceReportPayerFieldsModal.vue?vue&type=script&lang=js"
export * from "./BalanceReportPayerFieldsModal.vue?vue&type=script&lang=js"
import style0 from "./BalanceReportPayerFieldsModal.vue?vue&type=style&index=0&id=5dcc8b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcc8b44",
  null
  
)

export default component.exports